import { AfterContentInit, Component, ContentChild, EventEmitter, Input, OnInit, TemplateRef } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { Observable } from 'rxjs';
import { DetailComponent } from '../../models/detail-component';
import { TreeNodeEvent } from '../../models/tree-node-event';

@Component({
  selector: 'card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss']
})
export class CardViewComponent implements OnInit, DetailComponent, AfterContentInit {
  cardTemplate: TemplateRef<any>;

  @ContentChild(TemplateRef)
  contentTemplate: TemplateRef<any>;

  constructor() { }
  @Input()
  node: TreeNode;
  buttons$?: Observable<TemplateRef<any>>;
  refresh?: () => void;
  onRequestNodeUpdate = new EventEmitter<TreeNodeEvent>();

  ngOnInit(): void {
  }
  ngAfterContentInit() {
    if (this.contentTemplate) {
      this.cardTemplate = this.contentTemplate;
    }
  }

  selectCard(event, node) {
    this.onRequestNodeUpdate.emit({ type: 'select', node: node });
  }

  delete(event, item) {
    event.stopPropagation();
    this.onRequestNodeUpdate.emit({ type: 'delete', node: item });
    // console.log(this.tree);
    // const index = this.node.children.findIndex(p => p.key == item.key);
    // if (index >= 0) {
    //   this.node.children.splice(index, 1);
    // }
    // this.node.children = this.node.children.filter(p => p != item);
  }

}
